export default "__VITE_ASSET__OqdulJwh__"